import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // enabled: false,
      // refetchOnWindowFocus: false,
      retry: 3,
      staleTime: Infinity
    }
  }
});

export default queryClient;
